<template>
    <form-row title="Has your Loan Estimate been received?">
        <input-radio-boolean
            name="has_loan_estimate_been_received"
            :value="mortgage.has_loan_estimate_been_received"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
